module.exports = __webpack_public_path__ + "img/palette.07b50e.svg";